<template>
  <div class="ui large modal" ref="modal">
    <i class="close icon"></i>
    <div class="header">
      <i class="chart area icon"></i>
      {{ $t("course assignation statistics") }}
    </div>
    <div class="image scrolling content">
      <div class="ui small image">
        <img src="/images/icons/unlink.png" style="width: 100% !important" />
      </div>
      <div class="description" style="width: 100% !important">
        <canvas id="graphic"></canvas>

        <unassigned ref="unassigned" />
      </div>
    </div>
    <div class="actions">
      <div
        class="ui left floated purple icon right labeled button"
        @click="show_unassigned"
      >
        <i class="eye icon"></i>
        {{ $t("show unassigned") }}
      </div>
      <div class="ui blue icon right labeled deny button">
        <i class="remove icon"></i>
        {{ $t("close") }}
      </div>
    </div>
  </div>
</template>

<script>
// import { local_api, stringify } from "@/utils";
import {
  local_api,
  enterprise_setup,
  error_toast,
  // init_local_data_datables,
} from "@/utils";
import filters from "@/filters";
// import { groupBy } from "lodash";
import Chart from "chart.js";
// import { v4 } from "uuid";
// import { translate_status, translate_type } from "../local_translator";
import Unassigned from "./Unassigned.vue";

// filters.translate_status = translate_status;
// filters.translate_type = translate_type;

export default {
  name: "CourseAssignationStatisticsModal",
  filters: filters,
  components: { Unassigned },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  data() {
    return {
      preinscriptions: [],
      grouped: [],
      table: undefined,
      season_id: undefined,
    };
  },
  methods: {
    show_modal(data) {
      let vm = this;

      /**
       * get template
       */
      if (data) {
        if (data.uuid) {
          vm.season_id = data.uuid;
          vm.updateTransaction(data.uuid);
        }
      }

      window
        .jQuery(vm.$refs.modal)
        .modal({
          onVisible() {},
          onHide() {
            if (vm.table && vm.table.destroy) vm.table.destroy();
            vm.preinscriptions = [];
            vm.grouped = [];

            vm.$refs.unassigned.destroy();
          },
        })
        .modal("show");
    },
    updateTransaction(season_uuid) {
      let vm = this;
      local_api(vm, "post", "/course/revision/do-get-statistics", {
        u: season_uuid,
      })
        .then((rStatistics) => {
          // console.log(rStatistics);
          // vm.preinscriptions = rStatistics;

          // let grps = groupBy(rStatistics, (p) => {
          //   if (p.crs_assignation_section) return vm.$t("assigned");
          //   else return vm.$t("unassigned");
          // });
          // vm.grouped = Object.keys(grps).map((g) => {
          //   return { name: g, items: grps[g], uuid: v4() };
          // });

          const labels = rStatistics.map((k) => {
            return vm.$t(k.name);
          });

          const dt = rStatistics.map((k) => {
            return k.items;
          });

          // console.log("labels", labels);
          // console.log("dt", dt);

          // /** Chart */
          const data = {
            labels: labels,
            datasets: [
              {
                label: "",
                data: dt, // [65, 59, 80, 81, 56, 55, 40],
                backgroundColor: [
                  "rgba(255, 99, 132, 0.2)",
                  "rgba(255, 159, 64, 0.2)",
                  "rgba(255, 205, 86, 0.2)",
                  "rgba(75, 192, 192, 0.2)",
                  "rgba(54, 162, 235, 0.2)",
                  "rgba(153, 102, 255, 0.2)",
                  "rgba(201, 203, 207, 0.2)",
                ],
                borderColor: [
                  "rgb(255, 99, 132)",
                  "rgb(255, 159, 64)",
                  "rgb(255, 205, 86)",
                  "rgb(75, 192, 192)",
                  "rgb(54, 162, 235)",
                  "rgb(153, 102, 255)",
                  "rgb(201, 203, 207)",
                ],
                borderWidth: 1,
              },
            ],
          };

          const config = {
            type: "bar",
            data: data,
            options: {
              scales: {
                y: {
                  beginAtZero: true,
                },
              },
            },
          };
          // eslint-disable-next-line no-unused-vars
          const myChart = new Chart(document.getElementById("graphic"), config);

          setTimeout(() => {
            window.jQuery(vm.$refs.tabs).find(".item").tab();
            // let f = () => {};
            // vm.table = init_local_data_datables(vm, vm.$refs.table, f, f);
          }, 2000);

          // return grps;
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    show_unassigned() {
      let vm = this;
      vm.$refs.unassigned.init(vm.season_id);
    },
  },
  mounted() {},
  watch: {},
  updated: function () {},
};
</script>
